// Libraries
import { action, computed, observable } from "mobx";

// Core
import { StoresInstance } from "Core/Base";
import { FieldType, isEmptyOrWhitespace } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { RouteHelper } from "Custom/Utils";

// Custom
import { Client, Server } from "Custom/Globals/AppUrls";

export class HeaderLogoModel extends ViewModelBase<any> {
    constructor() {
        super({});
    }

    @action
    public handleNavBarLogoClick = async (): Promise<void> => {
        const propertyId = StoresInstance.domain.AccountStore.PropertyId;

        if (StoresInstance.domain.AccountStore && StoresInstance.domain.AccountStore.hasSuperAdminPermission) {
            this.history.push(RouteHelper.ClientRoutes.SuperAdmin());
        } else if (propertyId) {
            this.history.push(RouteHelper.ClientRoutes.Property(propertyId));
        }
    };

    @action
    public handleResetLogoClick = async (): Promise<void> => {
        this.history.push(RouteHelper.ClientRoutes.login());
    };

    @computed
    public get canDisplayCompanyLogo(): boolean {
        return !isEmptyOrWhitespace(StoresInstance.domain.AccountStore.CompanyLogo);
    }

    @computed
    public get companyLogo(): string {
        return StoresInstance.domain.AccountStore.CompanyLogo;
    }

    // #region Bolierplate

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
